import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'
import ActionBoxCard from '../ActionBoxCard/ActionBoxCTA'

const WhyRecootySection = () => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 0 })
  }, [])

  return (
    <div className={CSS.MoreToolsContainer} data-aos="fade-up">
      <div className={CSS.MoreTools}>
        <div className={CSS.Heading}>
          <h3>Why Recooty is the Best AI Job Description Generator</h3>
          {/* <p>
            Our tool is more than just a writer, it's a strategic partner in
            your hiring process. We’ve built a system that delivers tangible
            results.
          </p> */}
        </div>
        <div className={CSS.MTContainer}>
          <div className={CSS.ActionBox}>
            <ActionBoxCard
              icon="trending_up"
              heading="Optimized for Maximum Visibility"
              content={
                <>
                  Every AI-generated job description is automatically optimized
                  for SEO on Google and other <br /> search engines, as well as
                  for performance on social media and all major job boards.
                </>
              }
              button="Try for free"
              link="https://recooty.com/tools/hr-email-template-generator/"
              linkTarget="_blank"
              className={CSS.ActionBox3}
            />

            <div className={CSS.ActionSubBox}>
              <ActionBoxCard
                icon="edit_document"
                heading="Expertly Crafted, Superior Content: "
                content="Go beyond what templates or general AI like ChatGPT can offer. Our models are specifically trained on hiring language to produce superior qualifications, roles, and responsibilities sections."
                button="Try for free"
                link="https://recooty.com/tools/interview-question-generator/"
                linkTarget="_blank"
              />

              <ActionBoxCard
                icon="target"
                heading="Precision Targeting with Built-in Role-Intent"
                content="The AI understands the specific intent behind a role, ensuring the language used targets and attracts candidates with the precise skills and experience you need."
              />
              <ActionBoxCard
                icon="diversity_3"
                heading="Inclusive & Bias-Checked Language Engine"
                content="Automatically generate job descriptions that use inclusive, gender-neutral, and bias-free language, widening your talent pool and strengthening your employer brand."
              />
              <ActionBoxCard
                icon="business_center"
                heading="Aligned with 100+ Industries & AI ATS"
                content="Our job description builder is fine-tuned for over 100 industries and is designed to be compatible with modern Applicant Tracking Systems (AI ATS), ensuring your JD gets seen by the right people."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyRecootySection
